/**
 * Multipart upload helper (1.4 P24). `api()` JSON-encodes bodies, so file
 * uploads go through fetch directly with the same auth headers the client
 * uses (cookie + CSRF on web, bearer token on native).
 */
import { Platform } from 'react-native';
import { getToken, getCsrfToken, ApiError } from './client';
import { config } from '../config';

export async function uploadMultipart<T = unknown>(path: string, form: FormData): Promise<T> {
  const IS_WEB = Platform.OS === 'web';
  const headers: Record<string, string> = {};
  if (IS_WEB) {
    headers['X-Client-Type'] = 'web';
    const csrf = getCsrfToken();
    if (csrf) headers['X-CSRF-Token'] = csrf;
  } else {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  const resp = await fetch(`${config.apiUrl}${path}`, { method: 'POST', headers, body: form, ...(IS_WEB ? { credentials: 'include' as RequestCredentials } : {}) });
  let data: any = null;
  try { data = await resp.json(); } catch { /* no body */ }
  if (!resp.ok) throw new ApiError(data?.error || data?.message || `Upload failed (${resp.status})`, data?.code, data && typeof data === 'object' ? data : undefined);
  return data as T;
}
